import { NavigateBackLink } from '@exam-center/components';
import { RecurringExamEventCreationReviewDetails } from '@exam-center/exam-event-creation';
import { useParams } from '@exam-center/router';
import { Flex, PageHeader } from '@shared/components';

export default function RecurringExamEventReviewPage() {
  const { examCenterCode, year, month } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month/recurring-create/review',
  );

  return (
    <>
      <PageHeader
        title='สร้างรอบสอบใหม่'
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-events/years/:year/months/:month/recurring-create'
            params={{ examCenterCode, year, month }}
          />
        }
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          p: theme.spacing(6),
        })}
      >
        <RecurringExamEventCreationReviewDetails />
      </Flex>
    </>
  );
}
